import { render, staticRenderFns } from "./FavElement.vue?vue&type=template&id=96d4f07a&"
import script from "./FavElement.vue?vue&type=script&lang=js&"
export * from "./FavElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('96d4f07a')) {
      api.createRecord('96d4f07a', component.options)
    } else {
      api.reload('96d4f07a', component.options)
    }
    module.hot.accept("./FavElement.vue?vue&type=template&id=96d4f07a&", function () {
      api.rerender('96d4f07a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2h3AAIEzH6t42/JS/comp/FavElement.vue"
export default component.exports